export default "__VITE_ASSET__BZoRD3lJ__"